import React, { useState } from "react";

const useEmailValidation = (initialValue = "") => {
  const [value, setValue] = useState(initialValue);

  const [isValid, setIsValid] = useState(false);

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValid(emailRegex.test(email));
  };

  const setChange = (text) => {
    setValue(text);
  };

  return {
    isValid,
    validateEmail,
    value,
    setChange,
    handleChange: handleChange,
  };
};

export default useEmailValidation;
